import { ActorRefFrom } from 'xstate';
import { z } from 'zod';
import { ERROR_MESSAGES } from '~/constants';
import {
  employerInfoSchema,
  type EmployerInfoValues,
} from '~/features/employer/components/employerInfoSchema';
import { EmployerFacilityValues } from '~/features/market/facility/types';
import { Employer, EmployerUser } from '~/types';
import { employerRegistrationService } from './registration.service.machine';

export { employerInfoSchema, type EmployerInfoValues };

// Welcome Form
export const WelcomeSchema = z.object({
  email: z.email('Invalid email address'),
  tosAccepted: z.boolean().refine((value) => value, {
    message: ERROR_MESSAGES.REQUIRED,
  }),
  tosModalOpen: z.boolean(),
});
export type WelcomeValues = z.infer<typeof WelcomeSchema>;

export interface ViewContext {
  loading: boolean;
  userInfoId: number;
  welcomeForm: WelcomeValues;
  employerInfo: EmployerInfoValues;
  employerFacility: EmployerFacilityValues;
  employer?: Employer | undefined;
  employerUser?: EmployerUser | undefined;
  clerkUser?: string;
  registrationService: ActorRefFrom<typeof employerRegistrationService>;
}
